import React from "react";
import { CommonErrorPopup, ConfirmationPopup } from "component-library";
import { useTranslation } from "i18n";
import { AuthInstagramIntegrationCode } from "shared-types";
import { useDisconnectInstagramAccount } from "../hooks/useDisconnectInstagramAccount";

interface Props {
  disconnectPopUpToggle: () => void;
  instagramAccountId: number;
  profileId: string;
}

const DisconnectInstagramPopUp = ({
  disconnectPopUpToggle,
  profileId,
  instagramAccountId,
}: Props) => {
  const { t } = useTranslation();

  const { mutate, isLoading, error, reset } = useDisconnectInstagramAccount({
    profileId,
    instagramAccountId,
    onSuccessCallback: disconnectPopUpToggle,
  });

  const closeErrorPopup = () => {
    reset();
    disconnectPopUpToggle();
  };

  if (error)
    return (
      <CommonErrorPopup
        errorStatusCode={error?.response?.status}
        popupProps={{
          close: closeErrorPopup,
        }}
        alertMessageProps={{
          buttons: [
            {
              type: "primary",
              name: t("common:button.label.close"),
              click: closeErrorPopup,
            },
          ],
        }}
        errorCode={AuthInstagramIntegrationCode.Disconnect}
      />
    );

  return (
    <ConfirmationPopup
      classNames="dark:text-black c-font-primary"
      texts={{
        title: t("performer:profile.socialMedia.instagram.disconnect.title"),
        description: t(
          "performer:profile.socialMedia.instagram.disconnect.text"
        ),
        proceed: t(
          "performer:profile.socialMedia.instagram.disconnect.proceed"
        ),
        cancel: t("common:button.label.cancel"),
      }}
      handleProceed={() => mutate()}
      loading={isLoading}
      handleCancel={disconnectPopUpToggle}
    />
  );
};

export default DisconnectInstagramPopUp;
